export const SITE_ORIGIN = 'https://vieunite.com';

// These routes render the same components as their preferred public URLs.
const CANONICAL_ALIASES = {
    '/landing': '/',
    '/business': '/pro',
    '/business/home': '/pro',
    '/business/software': '/pro/software',
    '/business/ProSupportApp': '/pro/support/portal',
    '/business/TextureProSupport': '/pro/support/textura',
};

const ART_TABS = new Set(['artists', 'galleries', 'curation', 'videos']);

export function getCanonicalPath(matches) {
    if (!matches?.length) return null;

    // Use the declared routes rather than the requested URL to preserve the
    // site's slug casing, even when React Router matches a different casing.
    let pathname = '';
    for (const {route} of matches) {
        if (!route.path) continue;
        if (/[:*?]/.test(route.path)) return null;
        pathname = route.path.startsWith('/')
            ? route.path
            : `${pathname.replace(/\/$/, '')}/${route.path}`;
    }
    pathname = pathname.replace(/\/+$/, '') || '/';

    // Account routes can contain user-specific state and are not public pages.
    if (/^\/(artistportal|proportal)(\/|$)/i.test(pathname)) return null;
    return CANONICAL_ALIASES[pathname] ?? pathname;
}

export function buildCanonicalUrl(pathname, search = '') {
    if (!pathname) return null;
    const path = pathname.replace(/\/+$/, '') || '/';
    const url = new URL(path, SITE_ORIGIN);

    // Only content-changing parameters belong in a canonical. Tracking,
    // discount codes and account tokens must never become canonical URLs.
    if (path === '/art') {
        const tab = new URLSearchParams(search).get('page');
        if (ART_TABS.has(tab) && tab !== 'artists') {
            url.searchParams.set('page', tab);
        }
    }

    return url.href;
}
